// Third-party library imports.
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { isEmpty } from '../../../utils/helper';
import FontIcon from 'tcomponents/atoms/FontIcon';
// Local repo imports.
import PaletteName from '../PaletteName';
import PaletteAction from '../PaletteAction';
import { EMPTY_ARRAY, EMPTY_STRING, NO_OP } from '../../../constants/Constants';
import '../CheckboxPalette.scss';
import PaletteRowExpand from '../PaletteRowExpand';
class PaletteRow extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.handleActionClick = updatedActionData => {
      const {
        rowId,
        onRowClick,
        parentRowId,
        rowData
      } = this.props;
      let subKeys = [];
      if (isEmpty(parentRowId)) {
        var _rowData$subActions;
        subKeys = (_rowData$subActions = rowData.subActions) === null || _rowData$subActions === void 0 ? void 0 : _rowData$subActions.map(subAction => subAction.key);
        onRowClick([rowId], updatedActionData, subKeys);
      } else {
        onRowClick([parentRowId], updatedActionData, [rowId], true);
      }
    };
  }
  render() {
    const {
      rowData,
      parentRowId,
      onExpand,
      rowIndex,
      onRowClick,
      rowId
    } = this.props;
    const {
      label,
      actions,
      expanded
    } = rowData;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "palette-row"
    }, /*#__PURE__*/React.createElement(PaletteName, {
      name: label
    }, isEmpty(parentRowId) && /*#__PURE__*/React.createElement(PaletteRowExpand, {
      expanded: expanded,
      onExpand: () => onExpand(rowIndex)
    })), /*#__PURE__*/React.createElement(PaletteAction, {
      actions: actions,
      onClickAction: this.handleActionClick
    })), rowData.expanded && rowData.subActions.map(subAction => /*#__PURE__*/React.createElement(PaletteRow, {
      key: subAction.key,
      rowId: subAction.key,
      rowIndex: rowIndex,
      rowData: subAction,
      onRowClick: onRowClick,
      parentRowId: rowId
    })));
  }
}
PaletteRow.propTypes = {
  onRowClick: PropTypes.func,
  rowData: PropTypes.array,
  rowId: PropTypes.string
};
PaletteRow.defaultProps = {
  onRowClick: NO_OP,
  rowData: EMPTY_ARRAY,
  rowId: EMPTY_STRING
};
export default PaletteRow;